import * as serviceWorkerRegistration from '../../../serviceWorkerRegistration';
import { useEffect, useRef, useState } from 'react';
import Dialog from '../../../components/envago/Dialog/Dialog';
import Button from '../../../components/envago/Button/Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { offlineSelectors } from '../../../redux/offline';
import { reloadPage } from './reloadPage';

const CheckUpdates = () => {
    const { t } = useTranslation();

    const isOnline = useSelector(offlineSelectors.isOnline);
    const isOnlineRef = useRef(isOnline);
    useEffect(() => { isOnlineRef.current = isOnline; }, [isOnline]);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [serviceWorker, setServiceWorker] = useState<ServiceWorker>();

    useEffect(() => {

        serviceWorkerRegistration.register({
            onUpdate: (registration) => {
                const waitingServiceWorker = registration.waiting;

                if (waitingServiceWorker && isOnlineRef.current) {
                    setDialogVisible(true);
                    setServiceWorker(waitingServiceWorker);
                }
            }
        });
    }, []);

    if (dialogVisible) {
        return (
            <Dialog
                closable={true}
                onClose={() => {
                    setDialogVisible(false);
                    if(serviceWorker){
                        serviceWorker.postMessage({ type: 'SKIP_WAITING' });
                    }
                }}
                title={t('update.dialog.title')}
                visible={dialogVisible}
                actions={[
                    <Button
                        onClick={()=>{
                            setDialogVisible(false);
                            if(serviceWorker){
                                serviceWorker.postMessage({ type: 'SKIP_WAITING' });
                            }
                        }}
                        ghost={true}>{t('update.dialog.buttonNegative')}</Button>,
                    <Button
                        onClick={() => {
                            if (serviceWorker) {
                                serviceWorker.addEventListener('statechange', (event) => {
                                    if (event && event.target && 'state' in event.target) {
                                        if (event.target?.state === 'activated') {
                                            reloadPage();
                                        }
                                    }
                                });
                                serviceWorker.postMessage({ type: 'SKIP_WAITING' });
                            }
                        }}
                        primary={true}
                    >
                        {t('update.dialog.buttonPositive')}
                    </Button>,
                ]}
            >
                <div className={'max-w-md'}>
                    <p>{t('update.dialog.content')}</p>
                </div>
            </Dialog>
        );
    }

    return null;
};

export default CheckUpdates;
